import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';

//components
import DynamicLink from "../../components/routing/dynamicLink/dynamicLink";

//assets
import './footer.scss';
import logo from 'assets/icons/logo_white.svg';
import footerImg from 'assets/icons/footer_img.svg';
import mailIcon from 'assets/icons/mail_icon.svg';
import phoneIcon from 'assets/icons/phone_icon.svg';
import contactWhatsapp from 'assets/icons/whatsapp-footer.svg';


class Footer extends Component {

    render() {
        const text = this.props.text;

        const is_mobile = this.props.deviceState === 'mobile';
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';

        const footerItem = this.props.footerItems;

        let links = [];

        if(Object.keys(footerItem).length > 0) {
            for(let key in footerItem) {
                links.push(
                    <DynamicLink className='footerLink' data={footerItem[key].link} key={key}>
                        <span className='linkSpan'>{footerItem[key].title}</span>
                    </DynamicLink>);
            }
        }

        return (
            <footer className='footer'>
                <div className='infoContainer'>
                {!isLaptopOrDesktop &&
                <div className='topContainer'>
                    <div className='top'>
                        <span className='title'>{text['footer_title']}</span>
                        <div className='verticalDivider'/>
                        <img className='logo' src={logo} alt='logo'/>
                    </div>
                    <img className='divideImg' src={footerImg} alt="img"/>
                </div>
                }
                <div className='routeContainer'>
                <div className="indexContainer">
                    {links}
                </div>
                    {/*<div className={(is_mobile ? 'horizontalDivider' : 'verticalDivider')}/>*/}
                {/*<div className='contactInfoContainer'>*/}
                    {/*<a rel='noreferrer noopener' href={'mailto:' + text['contact_email']} className='contactInfo' style={isLaptopOrDesktop?{marginTop:0}:{} }>*/}
                        {/*<img className='contactIcon' src={mailIcon} alt='icon'/>*/}
                        {/*<span className='contactSpan'>{text['contact_email']}</span>*/}
                    {/*</a>*/}
                    {/*<a rel='noreferrer noopener' href={'tel:' + text['contact_phone']} className='contactInfo'>*/}
                        {/*<img className='contactIcon' src={phoneIcon} alt='icon'/>*/}
                        {/*<span className='contactSpan'>{text['contact_phone']}</span>*/}
                    {/*</a>*/}
                    {/*<a  href={'https://api.whatsapp.com/send?phone=' + text['contact_whatsapp_phone']}*/}
                       {/*target='_blank'*/}
                       {/*rel='noreferrer noopener'*/}
                       {/*className='contactInfo'>*/}
                        {/*<img className='contactIcon' src={contactWhatsapp} alt='icon'/>*/}
                        {/*<span className='contactSpan'>{text['contact_whatsapp_span']}</span>*/}
                    {/*</a>*/}
                {/*</div>*/}
                </div>
                {isLaptopOrDesktop &&
                <div className='topContainer'>
                    <div className='top'>
                        <span className='title'>{text['footer_title']}</span>
                        <div className='verticalDivider'/>
                        <img className='logo' src={logo} alt='logo'/>
                    </div>
                    <img className='divideImg' src={footerImg} alt="img"/>
                    <span className='footerSpan'>powered by <a rel='noreferrer noopener' href='http://www.inmanage.co.il' className='inmanageLink'>inManage</a></span>
                </div>
                }
                </div>
                {!isLaptopOrDesktop &&
                <Fragment>
                    <div className='horizontalDivider topMargin'/>
                    <span className='footerSpan'>powered by <a rel='noreferrer noopener' href='http://www.inmanage.co.il' className='inmanageLink'>inManage</a></span>
                </Fragment>
                }
            </footer>
        )
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        footerItems: store.config.FooterItem,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {

    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Footer);